import { Middleware } from '@nuxt/types'

const facebookCookieCheck: Middleware = ({ app, $auth }) => {
  if (!$auth.loggedIn) {
    return
  }

  const cookieFB = app.$cookies.get('FACEBOOK_ACCOUNT_MEMBERSHIP_PURCHASED')
  if (cookieFB) {
    const interval = setInterval(() => {
      // @ts-ignore
      if (typeof window.fbq !== 'undefined') {
        // @ts-ignore
        window.fbq('trackCustom', 'Sale-ALL', { value: cookieFB, currency: 'USD' }, { eventID: 'sale-all.' + $auth.user.id })
        app.$cookies.remove('FACEBOOK_ACCOUNT_MEMBERSHIP_PURCHASED')
        clearInterval(interval)
      }
    }, 1000)
  }
}

export default facebookCookieCheck
